import React, { useState } from "react";
import ReactDOM from "react-dom";

import BCMSModalState from "../../../../classes/BCMSModalState";

const BCMSModalContext = React.createContext(null);

export default function BCMSModalContainer({ modals, children }) {
    // If the modals property is undefined, set the property to an empty array
    modals = modals ?? {};
    // Create a state for the modal container
    // NOTE: Setting object "modals" so state updates correctly
    const [ state, setState ] = useState({ "modals" : new BCMSModalState(modals) });

    const open = (id, data) => setState({ "modals" : state.modals.open(id, data) });
    const close = id => setState({ "modals" : state.modals.close(id) });

    document.addEventListener("force-modal-open", evt => open(evt.detail.id, evt.detail.data));

    return (
        <BCMSModalContext.Provider value={{ "open" : open, "close" : close }}>
            {
                ReactDOM.createPortal(
                    <div className={ `bcms-modal-wrapper ${ state.modals.isActive ? "open" : "" }` }>
                        <div className="bcms-modal-overlay"></div>

                        {
                            [ ...state.modals.modals ].map(([ key, value ]) => {
                                const Component = value.component;
                                // Since this returns a fragment, must declare React.Fragment in order to add "key" property
                                return <React.Fragment key={ value.id }> 
                                        { value.isActive && <Component data={ value.data } /> } 
                                    </React.Fragment>;
                            }, [])
                        }
                    </div>,
                    document.querySelector("#root")
                )
            }

            { children }
        </BCMSModalContext.Provider>
    );
}

export const useBCMSModal = () => React.useContext(BCMSModalContext);